<template>
  <div
    :class="`${$browser()} ${finBrowser.IS_IOS_OR_ANDROID_APP?'app': 'web'} ${finBrowser.IS_IOS()?'ios': ''} wrapper fin-app`">
    <slot>
      <router-view/>
    </slot>
  </div>
</template>

<script>
import finBrowser from "@/js/finBrowser"
import {SplashScreen} from "@capacitor/splash-screen"
import {AppTrackingTransparency} from "capacitor-plugin-app-tracking-transparency"
import {FirebaseAnalytics} from "@capacitor-community/firebase-analytics"
import {Keyboard} from '@capacitor/keyboard'
import {EventBus} from "./plugins/fincraft"
import {App} from "@capacitor/app"
import {mapGetters} from "vuex"

// configure file aws-export depending on platform and environment for social media login
import aws_config from '@/aws-exports'
import * as AmplifyModules from "@/plugins/finAmplifyModules"
//import {Amplify} from "@/plugins/finAmplifyModules"
//Amplify.Logger.LOG_LEVEL = 'DEBUG'
// set the exact same values in redirectSignIn/redirectSignOut as in the AWS Cognito SignIn/SignOut Redirects
aws_config.oauth.redirectSignIn = finBrowser.IS_IOS_APP ? "capacitor://localhost/" :
  finBrowser.IS_ANDROID_APP ? "com.fincraft://signin/" : aws_config.oauth.redirectSignIn
aws_config.oauth.redirectSignOut = finBrowser.IS_IOS_APP ? "capacitor://localhost/" :
  finBrowser.IS_ANDROID_APP ? "com.fincraft/signout/" : aws_config.oauth.redirectSignOut
AmplifyModules.Auth.configure(aws_config)

export default {
  name: 'FinApp',
  data() {
    return {
      finBrowser: finBrowser
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  async mounted() {

    if (finBrowser.IS_IOS_OR_ANDROID_APP) {
      setTimeout(() => {
        SplashScreen.hide()
      }, 1500)

      Keyboard.addListener('keyboardDidShow', info => {
        EventBus.$emit('mobileKeyboardShow', info.keyboardHeight)
      })
      Keyboard.addListener('keyboardDidHide', () => {
        EventBus.$emit('mobileKeyboardHide')
      })

      // appUrlOpen is called per deep links configuration to open the url in the app instead of in the browser
      App.addListener('appUrlOpen', async (event) => {
        await this.handleDeepLink(event)
      })
    }

    // handling the tracking consent in the iOS App
    if (finBrowser.IS_IOS_APP) {
      const response = await AppTrackingTransparency.getStatus()
      if (response.status === "notDetermined") {
        await this.$router.push("/tracking")
      } else if (response.status === "denied") {
        await FirebaseAnalytics.setCollectionEnabled({
          enabled: false,
        })
      } else {
        // TODO TOTEST FINDEV-3820 this.handleAppsConsentToTracking()
        await FirebaseAnalytics.setCollectionEnabled({
          enabled: true
        })
      }
    }

    if (finBrowser.IS_ANDROID_APP) {
      // TODO TOTEST FINDEV-3820 this.handleAppsConsentToTracking()
      document.addEventListener("backbutton", this.backButtonEvent)
    }
  },
  beforeDestroy() {
    document.removeEventListener('backbutton', this.backButtonEvent)

    if (finBrowser.IS_IOS_OR_ANDROID_APP) {
      Keyboard.removeAllListeners()
    }
  },
  methods: {
    // handling the authentification via social media in the iOS and Android apps
    async handleDeepLink(event) {
      // event.url contains for the iOS App something like capacitor://localhost/?code=...&state=...
      // event.url contains for the Android App something like com.fincraft://signin/?code=...&state=...
      console.log("appUrlOpen event:", event)

      const params = new URLSearchParams(event.url.split("?")[1])
      if (params.has("local")) { // flag added to avoid a loop
        return
      }

      if (params.has("code") && params.has("state")) {
        // appPath contains something like '/?code=...&state=...'
        let appPath = "/?" + event.url.split("?")[1]
        console.log("appUrlOpen appPath", appPath)

        // In the iOS app and in the android app, _handleAuthResponse needs to be called via "http://localhost".
        // The flag local has been added to avoid a loop
        let url = "http://localhost" + appPath + `&local=${true}`

        try {
          // After the successful Cognito SignIn, we need to call Auth._handleAuthResponse and then call fetchUser,
          // in order to finalize the sign in process and get the user signed in in the application.

          // - The parameter url to call _handleAuthResponse has to be send from the same domain, where the signInRedirect sent the user to.
          // Otherwise. we would get a DOMException such as: Failed to execute 'replaceState' on 'History': A history state object ...
          // In the case of the android app, the only way to come back to the app is however per app link via url_scheme
          // (see file AndroidManifest.xml).
          // => IT IS IMPORTANT TO CATCH THIS ERROR BEFORE CONTINUING. Despite this error the user is signed successfully!

          // If the Redirects configured in the application and in Cognito do not match, the user is redirect to the browser to an url
          // containing something like fincraftapp.....?error=redirect_mismatch
          console.log("appUrlOpen calling Auth._handleAuthResponse", url)
          await this.$Amplify.Auth._handleAuthResponse(url)
        } catch (e) {
          console.error("failed to sign in user properly in the app", e)
        }

        try {
          console.log("appUrlOpen calling fetchuser")
          await this.$store.dispatch('auth/fetchUser')
          console.log("appUrlOpen this.user", this.user)
        } catch (e) {
          console.error("failed to fetchuser", e)
        }

        if (this.user) {
          this.$router.push(appPath).catch(() => {
          })
        }
      } else {
        console.log(`The event.url ${event.url} does not contain the params code and state. It is not a url-call due to a social login`)
      }

    },
    handleAppsConsentToTracking() {
      // send consent to GoogleTagManager

      // set cookie CookieConsent
      let cookieValue = 'statistics:true|marketing:true|functionality:true|security:true|preferences:true|'
      this.setCookie('CookieConsentApp', cookieValue, undefined)

      //window.dataLayer.push({event: 'gtm.init_consent', gtm.uniqueEventId: 1}) // TODO needed?
      //window.dataLayer.push({event: 'gtm.init', gtm.uniqueEventId: 46}) // TODO needed?
      window.dataLayer.push('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted'
      })

      // TODO remove the code setTimeout[...] below.
      // THis code is to test if the app events arrive until in amplitude
      setTimeout(() => {
        this.pushToAmplitude({
          'event': `fincraft_val_test`,
          'step': 'fincraft_val_test_cca_tmpl',
          'placement': `test`,
          'vue_breakpoint': this.$vuetify.breakpoint.name
        })
      }, 1000)

    },
    setCookie(cname, cvalue, exdays) {
      let expires = undefined
      if (exdays) {
        const d = new Date()
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        expires = "expires=" + d.toUTCString()
      }
      document.cookie = cname + "=" + cvalue + ";" + (expires ? expires : '') + ";path=/"
    },
    backButtonEvent() {
      if (this.$route.name === 'root' || this.$route.name === 'myFinHub') {
        navigator.app.exitApp()
      } else {
        this.$router.go(-1)
      }
    }
  }
}

</script>

<style lang="scss">
//@import "./styles/main";
.fin-toast-notification {
  padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px)) !important;
}

.ios {
  .keyboard-shown {
    top: calc(56px + env(safe-area-inset-top, 0px)) !important;
    position: relative;
  }

  header:not(.fin-tabs) {
    padding-top: env(safe-area-inset-top);
    height: calc(56px + env(safe-area-inset-top, 0px)) !important;
  }

  .finAgb > * {
    padding-top: env(safe-area-inset-top, 0px) !important;
  }

  .fin-tracking-info {
    .fin-logo-row {
      padding-top: env(safe-area-inset-top, 0px) !important;
    }

    .footer {
      bottom: env(safe-area-inset-bottom, 0px) !important;
    }
  }

  .fin-reduced-portfolio-details-title {
    padding-top: env(safe-area-inset-top, 0px) !important;
  }

  .registration-container {
    .header {
      padding-top: env(safe-area-inset-top, 0px) !important;
    }

    .footer {
      padding-bottom: env(safe-area-inset-bottom, 0px) !important;
    }
  }

  .demoToolContainer {
    padding-top: env(safe-area-inset-top, 0px) !important;
  }

  .fin-help-center-content-wrapper .close {
    top: env(safe-area-inset-top, 0px) !important;
  }

  .fin-lexicon-drawer .close_nav_buttons > .col {
    padding-top: env(safe-area-inset-top, 0px) !important;
  }

  .protected-app-main {
    padding-top: calc(56px + env(safe-area-inset-top, 0px)) !important;
  }

  .fin-dialog-content.v-dialog--fullscreen .fin-icon-close {
    top: env(safe-area-inset-top) !important;
  }

  .fin-onboarding {
    padding-top: env(safe-area-inset-top, 0px) !important;

    .v-app-bar {
      padding-top: env(safe-area-inset-top, 0px) !important;
    }

    .fin-onboarding-slider {
      &,
      .v-btn {
        padding-top: env(safe-area-inset-top, 0px) !important;
      }
    }
  }


  .fin-side-bottom-navigation {
    height: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .fin-side-navigation-mobile {
    .logo-block,
    .nav-content {
      padding-top: env(safe-area-inset-top, 0px) !important;
    }

    .v-navigation-drawer__append {
      height: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
      padding-bottom: env(safe-area-inset-bottom);
      background: $fin-color-primary-light;
    }
  }

  .fin-lexicon {
    padding-top: env(safe-area-inset-top, 0px) !important;
    padding-bottom: env(safe-area-inset-bottom);
  }

  .archetype-selector-dialog {
    padding-top: env(safe-area-inset-top, 0px) !important;
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
